import getClientsMin from './getClientsMin'

export const getClientsMinService = getClientsMin
